module.exports = __webpack_public_path__ + "img/banner-tc5.2a042813.jpg";